import { useState } from "react";
import { Brand } from "@/components/Layout";

export function useLang() {
  const init = new URLSearchParams(window.location.search).get("lang") || localStorage.getItem("pub-lang") || ((navigator.language || "it").startsWith("it") ? "it" : "en");
  const [lang, setLang] = useState(init === "en" ? "en" : "it");
  const set = (l) => { localStorage.setItem("pub-lang", l); setLang(l); };
  return [lang, set, (it, en) => (lang === "en" ? en : it)];
}

const LangSwitch = ({ lang, setLang }) => (
  <div className="absolute top-4 right-4 flex bg-white/90 rounded-full p-0.5 text-xs" data-testid="lang-switch">
    {[["it", "🇮🇹 IT"], ["en", "🇬🇧 EN"]].map(([k, l]) => <button key={k} onClick={() => setLang(k)} className={`px-2.5 py-1 rounded-full ${lang === k ? "bg-[#0D2B3A] text-white" : ""}`} data-testid={`lang-${k}`}>{l}</button>)}
  </div>
);

export const PublicShell = ({ children, testId, lang, setLang }) => (
  <div className="min-h-screen bg-gradient-to-b from-[#EAF5F7] via-[#F5FAFB] to-white" data-testid={testId}>
    <div className="relative h-56 sm:h-72 overflow-hidden">
      <img src="/img/mare1.jpg" alt="" className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0D2B3A]/40 to-[#0D2B3A]/80" />
      <div className="absolute top-4 left-4 bg-white/90 rounded-full px-3 py-1.5"><Brand small /></div>
      {setLang && <LangSwitch lang={lang} setLang={setLang} />}
    </div>
    <main className="max-w-xl mx-auto px-4 -mt-24 sm:-mt-32 relative pb-16 fade-up">{children}</main>
  </div>
);

export const Card = ({ children }) => <div className="rounded-2xl bg-white shadow-xl border border-[#D4E6EC] p-6 sm:p-8 space-y-4">{children}</div>;

export function Stars({ value, onChange, testId }) {
  return (
    <div className="flex gap-1" data-testid={testId}>
      {[1, 2, 3, 4, 5].map((n) => <button key={n} type="button" onClick={() => onChange(n)} className={`text-3xl leading-none transition-transform hover:scale-110 ${n <= (value || 0) ? "text-[#E3B04B]" : "text-[#D4E6EC]"}`} data-testid={`${testId}-${n}`} aria-label={`${n} stelle`}>★</button>)}
    </div>
  );
}
